import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { accentColor: String };

  connect() {
    this.updateAccentColor();
  }

  updateAccentColor() {
    const accentColor = this.accentColorValue || "#4292f0";

    const elements = document.querySelectorAll(".LegalPracticeAreaSection, .pa-icons-modal");
    elements.forEach(el => el.style.setProperty("--site-accent-color", accentColor));
  }
}
